import WichitaHeroSection from "./components/HeroSection";
import WichitaStickyNav from "./components/StickyNav";
import WichitaProcessingTimeSection from "./components/ProcessingTimeSection";
import WichitaServicesSection from "./components/ServicesSection";
import WichitaLocalAreaSection from "./components/LocalAreaSection";
import WichitaTestimonialsSection from "./components/TestimonialsSection";
import WichitaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import WichitaComparisonSection from "./components/ComparisonSection";
import WichitaMistakesSection from "./components/MistakesSection";
import WichitaHowItWorksSection from "./components/HowItWorksSection";
import WichitaFAQSection, { faqs } from "./components/FAQSection";
import WichitaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import WichitaFinalCTA from "./components/FinalCTA";
import WichitaTravelTimingSection from "./components/TravelTimingSection";
import WichitaDestinationsSection from "./components/DestinationsSection";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function WichitaPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Wichita"
        state="Kansas"
        stateAbbr="KS"
        route="/cities/wichita"
        title="Emergency Passport Wichita, KS — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Wichita, KS — as fast as 24 hours. Same-day courier processing available for McConnell AFB families, aerospace professionals at Spirit AeroSystems and Textron, Koch Industries executives, and WSU students. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Wichita, Kansas"
        geoPosition="37.6872;-97.3301"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Kansas"
        statePageRoute="/states/kansas"
      />
      <WichitaHeroSection />
      <WichitaStickyNav />
      <WichitaProcessingTimeSection />
      <WichitaServicesSection />
      <WichitaLocalAreaSection />
      <WichitaTravelTimingSection />
      <WichitaDestinationsSection />
      <WichitaTestimonialsSection />
      <WichitaAcceptanceFacilitiesSection />
      <WichitaComparisonSection />
      <WichitaMistakesSection />
      <WichitaHowItWorksSection />
      <WichitaFAQSection />
      <WichitaHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/wichita" state="KS" />
      <WichitaFinalCTA />
    </div>
  );
}